import React, {Fragment, useEffect, useState} from 'react'
import {
    reqImportOrder, reqImportCustomsPorts, reqImportVehicleTypes, reqGnArea, reqAddress,
    reqCreateImportOrder, reqUpdateImportOrder, baseUrl, reqFileList,
} from '../../api'
import {Form, Input, Button, Table, DatePicker, message, Select, Radio, Row, Col, Popconfirm, Upload} from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
import {getInformation, range,} from "../../utills/common";
import {convertToOptions} from "../../components/options";
import {convertToRadios} from "../../components/radios";
import constants, {I_DELIVERY_TYPE, I_ENTRUST_TYPE, I_SUB_TYPE} from "../../utills/constants";
import OrderRemarkView from "./order-remark-view";
import PhotoFileFormItem from '../../components/photo-file/photo-file-form-item'
import EditableCell, {EditableContext} from "../../components/Editable/edit-cell";

const AuthButton = authorizeBase(Button)
moment.locale('zh-cn');

function ImportOrder(props) {
    const [deliveryType, setDeliveryType] = useState(null);
    const [entrustType, setEntrustType] = useState(null);
    const [readOnly, setReadOnly] = useState(false);//可以编辑：新建，驳回,
    const [orderId, setOrderId] = useState(null);
    const [order, setOrder] = useState({});
    const [dBtn, setDBtn] = useState(false);
    const {getFieldDecorator, setFieldsValue} = props.form;
    //数据源
    const [vehicleTypeObj, setVehicleTypeObj] = useState({});
    const [customsPortArray, setCustomsPortArray] = useState([]);
    const [destinationArray, setDestinationArray] = useState([]);
    const [storageArray, setStorageArray] = useState([]);
    //箱货信息
    const [tableDataSource, setTableDataSource] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const [latestKey, setLatestKey] = useState(-1);

    useEffect(() => {
        const orderId = props.location.state && props.location.state.orderId;
        if (orderId) {
            setOrderId(orderId)
            getImportOrder(orderId)
        }
        getAreas();
        getVehicleTypes()
        getStorages(3);//国内仓
    }, []);
    useEffect(() => {
        if (deliveryType != null && Object.keys(vehicleTypeObj).length > 0) {
            setFieldsValue({cabinetType: order.cabinetType})
        }
    }, [deliveryType, vehicleTypeObj]);
    useEffect(() => {
        if (deliveryType != null) {
            getCustomsPorts(deliveryType)
            if (!orderId) {
                setTableDataSource([])
                setEditingKey('')
            }
        }
    }, [deliveryType]);
    useEffect(() => {
        if (entrustType != null) {
            setFieldsValue({destinationCity: order.destinationCity})
        }
    }, [entrustType]);
    //目的地
    const getAreas = async () => {
        let result = await reqGnArea();
        if (result.code == 200) {
            setDestinationArray(result.data)
        } else {
            message.error(result.message)
        }
    };
    //国内仓
    const getStorages = async (type) => {
        let result = await reqAddress(type);
        if (result.code == 200) {
            setStorageArray(result.data)
        } else {
            message.error(result.message)
        }
    };
    //口岸
    const getCustomsPorts = async (deliveryType) => {
        let result = await reqImportCustomsPorts(deliveryType);
        if (result.code === 200) {
            setCustomsPortArray(result.data)
        } else {
            message.error(result.message)
        }
    }
    //车型
    const getVehicleTypes = async () => {
        let result = await reqImportVehicleTypes();
        if (result.code == 200) {
            const a = result.data.entries()
            const data = {}
            result.data.forEach((o, i) => {
                data[o] = o;
            })
            setVehicleTypeObj(data)
        } else {
            message.error(result.message)
        }
    };
    const getImportOrder = async (id) => {
        let result = await reqImportOrder(id)
        if (result.code === 200) {
            const order = {entName: result.data.entName, ...result.data.orderDo}
            judgeReadOnly(order.orderStatus)
            setDeliveryType(order.deliveryType)
            setEntrustType(order.entrustType)
            order.estimatePortDt = order.estimatePortDt ? moment(order.estimatePortDt) : null;
            setFieldsValue({...order})
            getFileList('billLadingIds', id, 'import_order_lading_bill');
            getFileList('contractIds', id, 'import_order_contract');
            getFileList('invoiceIds', id, 'import_order_invoice');
            setOrder(order)
            //箱货信息
            const orderDelivery = {...result.data.orderDelivery}
            getFileList('fileIds', id, 'import_order_box_note', orderDelivery);

        } else {
            message.error(result.message)
        }
    }
    const getFileList = async (name, orderId, objectType, orderDelivery) => {
        let po = {orderId, objectType, pageNum: 1, pageSize: 10};
        const result = await reqFileList(po);
        if (result.code === 200) {
            const fileList = setFileUrl(result.data.rows);
            if (name === 'fileIds') {
                setTableDataSource([{...orderDelivery, fileIds: fileList}])
            } else {
                setFieldsValue({[name]: fileList})
            }
        } else {
            message.error(result.message)
        }
    }
    const setFileUrl = (fileList) => {
        (fileList || []).forEach((item, index) => {
            item.uid = index;
            item.name = item.fileName;
            item.status = 'done';
            item.url = baseUrl + '/' + item.filePath;
            item.thumbUrl = item.url;
        });
        return fileList;
    };
    const judgeReadOnly = orderStatus => {
        const flag1 = orderStatus === 'new' || orderStatus === 'failed'
        setReadOnly(!flag1)
    };
    const handleSaveSubmit = (e, isCommit) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return
            }
            setDBtn(true)
            values.isCommit = isCommit ? isCommit : 'N'
            //预计抵达时间
            values.estimatePortDt = values.estimatePortDt ? values.estimatePortDt.format('YYYY-MM-DD HH:mm:ss') : '';
            saveOrder(values)
        });
    }
    const saveOrder = async (data) => {
        if (orderId) {
            data.id = orderId;
            data = {...tableDataSource[0], ...data,};
            let result = await reqUpdateImportOrder(data)
            if (result.code === 200) {
                message.success(result.message)
                props.history.replace('/import/orderList')
            } else {
                message.error(result.message)
            }
            setDBtn(false)
        } else {
            data.billLadingIds = Array.isArray(data.billLadingIds) ? data.billLadingIds.map(o => o.id ? o.id : o.response.data.id) : [];
            data.contractIds = Array.isArray(data.contractIds) ? data.contractIds.map(o => o.id ? o.id : o.response.data.id) : [];
            data.invoiceIds = Array.isArray(data.invoiceIds) ? data.invoiceIds.map(o => o.id ? o.id : o.response.data.id) : [];
            const boxes = []
            for (const row of tableDataSource) {
                if (!!row.boxNo) {
                    const box = {...row}
                    box.fileIds = Array.isArray(box.fileIds) ? box.fileIds.map(o => o.id ? o.id : o.response.data.id) : [];
                    boxes.push(box)
                }
            }
            data.importDeliveryList = boxes;
            let result = await reqCreateImportOrder(data)
            if (result.code === 201) {
                message.success(result.message)
                props.history.replace('/import/orderList')
            } else {
                message.error(result.message)
            }
            setDBtn(false)
        }
    }

    //预计提货时间：提前48小时下单
    const disabledStartDate = (current) => {
        return current && current < moment().add('days', 1).endOf('day');
    };
    const disabledDateTime = (current) => {
        if (current && current < moment().add('days', 2).endOf('day')) {
            const hour = new Date().getHours();
            return {
                disabledHours: () => range(0, hour + 1),
            };
        }
    };
    const handleChangeStorage = (value) => {
        const data = storageArray.filter((o, i) => value === o.id)
        if (data.length > 0) {
            const info = getInformation(data[0])
            props.form.setFieldsValue({
                storageAddr: info.address,
                storageContact: data[0].contact,
                storageTel: info.tel.toString()
            })
        }
    }
    const columns = [{
        title: '* 箱号',
        dataIndex: 'boxNo',
        editable: true,
        required: true,
    }, {
        title: '* 铅封号',
        dataIndex: 'sealNo',
        editable: true,
        required: true,
    }, {
        title: '件数',
        dataIndex: 'pcsNumber',
        editable: true,
        required: false,
        inputType: 'number',
    }, {
        title: '重量',
        dataIndex: 'weight',
        editable: true,
        required: false,
        inputType: 'number',
    }, {
        title: '箱单号',
        dataIndex: 'boxNoteNo',
        editable: true,
        required: false,
    }, {
        title: '上传箱单',
        dataIndex: 'fileIds',
        editable: true,
        required: false,
        inputType: 'file',
        render: (text, record) => {
            const images = (text || []).map(o => {
                if (o.url) {
                    return <img src={o.url} width={100}/>
                }
                return <img src={baseUrl + '/' + o.response.data.filePath} width={100}/>
            })
            return images
        }
    }, {
        title: '操作',
        dataIndex: 'opt',
        render: (text, record) => {
            const editable = isEditing(record);
            return editable ? (
                <Fragment>
                    <EditableContext.Consumer>
                        {form => (
                            <Button type='link' onClick={() => save(form, record.key)} style={{marginRight: 8}}>
                                保存
                            </Button>)}
                    </EditableContext.Consumer>
                    <Button type='link' onClick={() => cancel()}>取消</Button>
                </Fragment>
            ) : (!readOnly && <Fragment>
                <Button type='link' disabled={editingKey !== ''} onClick={() => edit(record.key)}>修改</Button>
                {!orderId && <Popconfirm title="是否确定删除?" onConfirm={() => del(record.key)}>
                    <Button type='link'>删除</Button>
                </Popconfirm>}
            </Fragment>)
        }
    },];
    let editCols = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: record => ({
                record,
                inputType: col.inputType ? col.inputType : 'text',
                options: col.options,
                dataIndex: col.dataIndex,
                title: col.title,
                required: col.required,
                editing: isEditing(record),
            }),
        };
    });
    const isEditing = record => record.key === editingKey;
    const edit = (key) => {
        setEditingKey(key)
    }
    const cancel = () => {
        setEditingKey('')
    };
    const save = (form, key) => {
        form.validateFields(['boxNo', 'sealNo', 'pcsNumber', 'weight', 'boxNoteNo'], (error, row) => {
            if (error) {
                return;
            }
            const fileIds = form.getFieldValue('fileIds')
            row.fileIds = fileIds
            const newData = [...tableDataSource];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                let newItem = Object.assign(item, row)
                newData.splice(index, 1, {
                    ...item,
                    ...newItem,
                });
            } else {
                newData.push(row);
            }
            setTableDataSource(newData)
            setEditingKey('')
        });
    }
    const add = () => {
        const newKey = latestKey + 1
        setLatestKey(newKey)
        setTableDataSource([...tableDataSource, {key: newKey}])
    };
    const del = (key) => {
        const newData = [...tableDataSource];
        const index = newData.findIndex(item => key === item.key);
        if (index > -1) {
            newData.splice(index, 1)
            setTableDataSource(newData)
        }
    };
    const downloadModel = () => {
        window.location.href = baseUrl.replace('/oms', '/upload') + '/template/箱货信息导入模板.xlsx';
    }
    //导入箱货
    const handleChangeBox = ({file}) => {
        if (file.status === 'done') {
            if (file.response && file.response.code === 200) {
                const boxes = [...tableDataSource, ...file.response.data]
                setTableDataSource(boxes)
            }
        }
    }
    const listFormItemLayout = {
        labelCol: {lg: {span: 4}, md: {span: 8},},
        wrapperCol: {lg: {span: 20}, md: {span: 16},},
    }
    return (
        <div className='order-ticket box-shadow'>
            <div
                className="head-title">{orderId ? '修改进口运输订单 ' + (order.orderNo ? order.orderNo : '') : '新建进口运输订单'}</div>
            {orderId && <OrderRemarkView orderId={orderId}/>}
            <div className="order-ticket-content">
                <Form {...listFormItemLayout} onSubmit={handleSaveSubmit}>
                    <div className="order-spaceInfo-content">
                        <div className='content-head-title'>委托类型</div>
                        <div className='spaceInfo-content-info'>
                            <Form.Item label="运输类型">
                                {getFieldDecorator('deliveryType', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group onChange={e => setDeliveryType(e.target.value)} disabled={readOnly}>
                                    {convertToRadios(I_DELIVERY_TYPE)}
                                </Radio.Group>)}
                            </Form.Item>
                            <Form.Item label="委托方式">
                                {getFieldDecorator('entrustType', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group onChange={e => setEntrustType(e.target.value)} disabled={readOnly}>
                                    {convertToRadios(I_ENTRUST_TYPE[deliveryType])}
                                </Radio.Group>)}
                            </Form.Item>
                            <Form.Item label="入境口岸">
                                {getFieldDecorator('customsPort', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Select disabled={readOnly}>
                                    {convertToOptions(customsPortArray, 'customsPortCode', 'customsPortCode', 'customsPortName')}
                                </Select>)}
                            </Form.Item>
                            <Form.Item label="预计抵达时间">
                                {getFieldDecorator('estimatePortDt', {
                                    rules: [{required: true, message: '该项必填'}],
                                })(<DatePicker className='whole'
                                               format="YYYY-MM-DD HH"
                                               showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                               disabled={readOnly}
                                />)}
                            </Form.Item>
                            <Form.Item label="服务类型">
                                {getFieldDecorator('subType', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group disabled={readOnly}>
                                    {convertToRadios(I_SUB_TYPE[deliveryType])}
                                </Radio.Group>)}
                            </Form.Item>
                            {deliveryType === 'YIT' && <Form.Item label="倒装车型">
                                {getFieldDecorator('cabinetType', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Radio.Group disabled={readOnly}>
                                    {convertToRadios(vehicleTypeObj)}
                                </Radio.Group>)}
                            </Form.Item>}
                            {entrustType === 'p2w' && <Form.Item label="目的地">
                                {getFieldDecorator('destinationCity', {
                                    rules: [{required: true, message: '该项必填'}]
                                })(<Select showSearch={true} optionFilterProp="children" disabled={readOnly}>
                                    {convertToOptions(destinationArray, 'cityId', 'city', 'city')}
                                </Select>)}
                            </Form.Item>}
                        </div>
                    </div>
                    <div className='content-head-title'>其他信息</div>
                    <div className='spaceInfo-content-info'>
                        <Row>
                            <Col span={12}>
                                <Form.Item label="提单号">
                                    {getFieldDecorator('ladingBillNo',)(<Input readOnly={readOnly}/>)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <PhotoFileFormItem getFieldDecorator={getFieldDecorator} label='提单' name='billLadingIds'
                                                   required={false}
                                                   fileType='import_order_lading_bill' orderId={orderId}/>
                            </Col>
                            <Col span={12}>
                                <PhotoFileFormItem getFieldDecorator={getFieldDecorator} label='发票' name='invoiceIds'
                                                   required={true}
                                                   fileType='import_order_invoice' orderId={orderId}/>
                            </Col>
                            <Col span={12}>
                                <PhotoFileFormItem getFieldDecorator={getFieldDecorator} label='合同' name='contractIds'
                                                   required={true}
                                                   fileType='import_order_contract' orderId={orderId}/>
                            </Col>
                        </Row>
                    </div>
                    <div className='content-head-title'>箱货信息
                        {!orderId && deliveryType === 'YIN' && <div>
                            <Button style={{marginRight: '10px'}} onClick={downloadModel}>下载模板</Button>
                            <Upload showUploadList={false}
                                    action={baseUrl + '/api/v1/p/oms/importOrder/import'}
                                    withCredentials={true}
                                    onChange={handleChangeBox}>
                                <Button>导入</Button>
                            </Upload>
                        </div>}
                    </div>
                    <div className='spaceInfo-content-info'>
                        <EditableContext.Provider value={props.form}>
                            <Table
                                components={{body: {cell: EditableCell,}}}
                                rowKey='key'
                                size="middle"
                                bordered
                                rowClassName="editable-row"
                                columns={editCols}
                                dataSource={tableDataSource}
                                pagination={false}
                            />
                        </EditableContext.Provider>
                        {(!orderId && (deliveryType === 'YIN' || (deliveryType === 'YIT' && tableDataSource < 1))) &&
                        <Button onClick={add}>新增</Button>}
                    </div>
                    <div className='content-head-title'>国内仓库信息</div>
                    <div className='spaceInfo-content-info'>
                        <div className='info-content'>仓库联系人信息：</div>
                        <Select onChange={handleChangeStorage} disabled={readOnly}>
                            {convertToOptions(storageArray, 'id', 'id', 'company')}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="地址">
                                        {getFieldDecorator('storageAddr', {
                                            rules: [{required: entrustType === 'p2w', message: '该项必填'}]
                                        })(<Input readOnly={readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="联系人">
                                        {getFieldDecorator('storageContact', {
                                            rules: [{required: entrustType === 'p2w', message: '该项必填'}]
                                        })(<Input readOnly={readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="联系方式">
                                        {getFieldDecorator('storageTel', {
                                            rules: [{required: entrustType === 'p2w', message: '该项必填'}]
                                        })(<Input readOnly={readOnly}/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    {!readOnly && <div className='box-submit'>
                        <AuthButton authority="order_start:commit" type="primary" htmlType="submit"
                                    style={{marginRight: '10px'}} disabled={dBtn}>保存</AuthButton>
                        <AuthButton authority="order_start:commit" type="primary"
                                    onClick={e => handleSaveSubmit(e, 'Y')} disabled={dBtn}>保存并提交</AuthButton>
                    </div>}
                </Form>
            </div>
        </div>
    )
}

const importOrderForm = authorizePage("order_start:commit")(Form.create()(ImportOrder))
export default importOrderForm